import React, { PureComponent } from "react";
import clsx from "clsx";
import {
  Metric,
  selectFormat,
  Error,
  getCountryFlag,
} from "components/Utils/Utils.js";

class WorldCupMatchesYesterday extends PureComponent {
  render() {
    const { data, url } = this.props;

    if (data.data.hasData === false) {
      return <Error minHeight={260} />;
    }

    const renderChannels = () =>
      data.data.channels.map((channel, index) => {
        return (
          <div className="col-12" key={index}>
            <div className="row">
              <div className="col-12 row-divider">
                <img
                  src={`https://d1fh34r1lqg2ii.cloudfront.net/logos/${channel.name}.svg`}
                  alt={`${channel.name}`}
                  className="channel-logo"
                />
              </div>
              <div className="divider-dotted-spaced"></div>
            </div>

            {renderMatches(channel.matches)}
          </div>
        );
      });

    const renderMatches = (matches) =>
      matches.map((match, index) => (
        <div key={index}>
          <div className="row">
            <div className="mt-4 mb-4 col-3">
              <div className="mb-1 info-heading">
                <span className="mr-1 world-cup-country-flag-icon">
                  {getCountryFlag(match.meta.teams[0].country)}
                </span>
                {match.meta.teams[0].team} vs{" "}
                <span className="mr-1 world-cup-country-flag-icon">
                  {getCountryFlag(match.meta.teams[1].country)}{" "}
                </span>
                {match.meta.teams[1].team}
              </div>
              <div className="mb-1 info-detail">
                Air Time:{" "}
                <span className="info-value">{match.meta.air_time}</span>
              </div>
              <div>
                <span className="info-detail">
                  Match: <span className="info-value">{match.meta.match}</span>
                </span>
                <span className="ml-2 info-detail">
                  Stage: <span className="info-value">{match.meta.stage}</span>
                </span>
              </div>
            </div>

            <div className="mt-4 mb-4 col-3 d-flex align-items-center">
              <div className="mx-2 d-flex">
                <div
                  className={clsx("progress-bar-lg cell-chart", {
                    progress:
                      match["Preliminary TAD Persons 2+"][0].chart !== "0%",
                    "progress-no-value":
                      match["Preliminary TAD Persons 2+"][0].chart === "0%",
                  })}
                >
                  <div
                    className="progress-bar progress-bar-orange"
                    role="progressbar"
                    style={{
                      width: match["Preliminary TAD Persons 2+"][0].chart,
                    }}
                    aria-valuenow={match["Preliminary TAD Persons 2+"][0].chart}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                {match["Preliminary TAD Persons 2+"][0].metric.value > 0 && (
                  <div className="ml-2 d-flex justify-content-center align-items-center world-cup-primary-metric-gray">
                    <Metric
                      size={"xs"}
                      value={
                        match["Preliminary TAD Persons 2+"][0].metric.value
                      }
                      format="0,0"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="mt-4 mb-4 col-3 d-flex align-items-center">
              <div className="mx-2 d-flex">
                <div
                  className={clsx("progress-bar-lg cell-chart", {
                    progress: match["Preliminary Linear P2+"][0].chart !== "0%",
                    "progress-no-value":
                      match["Preliminary Linear P2+"][0].chart === "0%",
                  })}
                >
                  <div
                    className="progress-bar progress-bar-teal"
                    role="progressbar"
                    style={{
                      width: match["Preliminary Linear P2+"][0].chart,
                    }}
                    aria-valuenow={match["Preliminary Linear P2+"][0].chart}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                {match["Preliminary Linear P2+"][0].metric.value > 0 && (
                  <div className="ml-2 d-flex justify-content-center align-items-center world-cup-primary-metric-gray">
                    <Metric
                      size={"xs"}
                      value={match["Preliminary Linear P2+"][0].metric.value}
                      format="0,0"
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="mt-4 mb-4 col-3 d-flex align-items-center">
              <div className="mx-2 d-flex">
                <div
                  className={clsx("progress-bar-lg cell-chart", {
                    progress: match["Streaming Minutes"][0].chart !== "0%",
                    "progress-no-value":
                      match["Streaming Minutes"][0].chart === "0%",
                  })}
                >
                  <div
                    className="progress-bar progress-bar-yellow"
                    role="progressbar"
                    style={{
                      width: match["Streaming Minutes"][0].chart,
                    }}
                    aria-valuenow={match["Streaming Minutes"][0].chart}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  ></div>
                </div>

                {match["Streaming Minutes"][0].metric.value > 0 && (
                  <div className="ml-2 d-flex justify-content-center align-items-center world-cup-primary-metric-gray">
                    <Metric
                      size={"xs"}
                      value={match["Streaming Minutes"][0].metric.value}
                      format="0,0"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {index < matches.length - 1 && (
            <div className="divider-dotted-spaced"></div>
          )}
        </div>
      ));

    return (
      <div className="row">
        {!url.includes("world-cup-upcoming-matches") && (
          <div className="col-12">
            <div className="flex">
              <span>
                Date:{" "}
                <span className="column-header">
                  {selectFormat("date", data.meta.date, "dddd MMMM Do YYYY")}
                </span>
                <span className="mx-2">|</span>
              </span>

              <span>
                Match Day:{" "}
                <span className="column-header">{data.meta.match_day}</span>{" "}
                <span className="mx-2">|</span>
              </span>

              <span>
                Games Played:{" "}
                <span className="column-header">{data.meta.games_played}</span>
                {/* <span className="mx-2">|</span> */}
              </span>

              {/* <span>
                Total Games to Date:{" "}
                <span className="column-header">
                  {data.meta.total_games_to_date}
                </span>
              </span> */}
            </div>
          </div>
        )}
        <div className="col-12">
          <small className="info-format">
            All values are in Thousands (000)
          </small>
        </div>

        {data.data.channels.length > 0 ? (
          <>
            <div className="mt-4 col-12">
              <div className="row">
                <div className="col-3">
                  <div className="text-left column-header">Match</div>
                </div>
                <div className="col-3">
                  <div className="mx-2 column-header">
                    Preliminary TAD Persons 2+
                  </div>
                </div>
                <div className="col-3">
                  <div className="mx-2 column-header">
                    Preliminary Linear Persons 2+
                  </div>
                </div>
                <div className="col-3">
                  <div className="mx-2 column-header">Streaming Minutes</div>
                </div>
              </div>
            </div>

            {renderChannels()}
          </>
        ) : (
          <div className="mt-5">
            <p className="world-cup-no-matches">
              There is no match data for this day.
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default WorldCupMatchesYesterday;
